// VolunteerSection.jsx
import React, { useState, useContext } from "react";
import "../../../assets/css/student/donorscreen/DonorHero.css";
import volunteerImg from "../../../assets/images/donor/Volunteer-image.jpg";
import AppContext from '../../../context/AppContext';

const VolunteerSection = () => {
  const { baseUrl, regExpChecker } = useContext(AppContext);
  // Inputs
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [privacy, setPrivacy] = useState(false);

  // Skills (checkboxes)
  const [fee, setFee] = useState(false);
  const [books, setBooks] = useState(false);
  const [uniform, setUniform] = useState(false);

  // Errors
  const [nameError, setNameError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");

  const [vsFormData, setVsFormData] = useState({
    name: "",
    phone: "",
    email: "",
    skills: {
      firstAid: false,
      teaching: false,
      financialAid: false,
      childcare: false,
      humanRights: false,
      other: false,
    },
    additionalInfo: "",
    privacy: false,
  });

  const [vsSubmitted, setVsSubmitted] = useState(false);

  // ============ INPUT HANDLER ============
  const handleVsInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox" && name in vsFormData.skills) {
      setVsFormData((prev) => ({
        ...prev,
        skills: {
          ...prev.skills,
          [name]: checked,
        },
      }));
    } else {
      setVsFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  // ============ SUBMIT HANDLER ============
  const handleVsSubmit = (e) => {
    e.preventDefault();
    if (!vsFormData.privacy) {
      alert("Please agree to the privacy policy.");
      return;
    }
    console.log("Volunteer Form Submitted:", vsFormData);
    setVsSubmitted(true);
  };

  return (
    <>
      {/* ===== HERO SECTION ===== */}
      <div className="vs-hero">
        <div className="vs-hero-overlay" />
        <div className="vs-hero-content">
          <h1 className="vs-hero-title">
            Become a <span className="vs-hero-highlight">charity</span> volunteer
          </h1>
          <p className="vs-hero-subtitle">
            Register today and join us in our mission and vision to save
            <br /> and change lives for the better.
          </p>
          {/* <p className="vs-hero-breadcrumb">
            Home &rsaquo; Pages &rsaquo; <strong>Volunteer – Modern</strong>
          </p> */}
        </div>

        {/* Wave SVG */}
        <div className="vs-hero-wave">
          <svg
            viewBox="0 0 1440 80"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              d="M0,40 C180,80 360,0 540,40 C720,80 900,0 1080,40 C1260,80 1380,20 1440,40 L1440,80 L0,80 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </div>

      {/* ===== FORM CARD SECTION ===== */}
      <div className="vs-section">
        <div className="vs-card">

          {/* LEFT — Form */}
          <div className="vs-card-left">
            {vsSubmitted ? (
              <div className="vs-success">
                <svg className="vs-success-icon" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor"
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                <h3>Request Submitted!</h3>
                <p>Thank you! We will get back to you shortly.</p>
              </div>
            ) : (
              <form className="vs-form" onSubmit={handleVsSubmit} noValidate>

                {/* Contact Details */}
                <h3 className="vs-form-heading">Contact details</h3>

                <input
                  type="text"
                  name="name"
                  className="vs-input"
                  placeholder="Your name *"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameError(regExpChecker('username', e.target.value));
                  }}
                  required
                />
                <p style={{ color: "red" }}>{nameError}</p>
                <input
                  type="tel"
                  name="phone"
                  className="vs-input"
                  placeholder="Phone number *"
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    setPhoneError(regExpChecker('phone', e.target.value));
                  }}
                  required
                />
                <p style={{ color: "red" }}>{phoneError}</p>
                <input
                  type="email"
                  name="email"
                  className="vs-input"
                  placeholder="Email address *"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError(regExpChecker('email', e.target.value));
                  }}
                  required
                />
                <p style={{ color: "red" }}>{emailError}</p>
                {/* Skillsets */}
                <h3 className="vs-form-heading vs-form-heading--gap">
                  Skillsets or area of interests
                </h3>

                <div className="vs-checkbox-grid">
                  {[
                    { name: "fee", label: "Fee" },
                    { name: "books", label: "Books" },
                    { name: "uniform", label: "Uniform" },
                  ].map((skill) => (
                    <label key={skill.name} className="vs-checkbox-label">
                      <input
                        type="checkbox"
                        name={skill.name}
                        className="vs-checkbox"
                        checked={vsFormData.skills[skill.name]}
                        onChange={handleVsInputChange}
                      />
                      {skill.label}
                    </label>
                  ))}
                </div>

                {/* Additional Info */}
                <h3 className="vs-form-heading vs-form-heading--gap">
                  Additional information (optional)
                </h3>

                <textarea
                  name="additionalInfo"
                  className="vs-textarea"
                  placeholder="Anything else you would like us to know?"
                  rows={5}
                  value={additionalInfo}
                  onChange={(e) =>
                    setAdditionalInfo(e.target.value)}
                />

                {/* Privacy */}
                <div className="vs-privacy-row">
                  <input
                    type="checkbox"
                    name="privacy"
                    id="vs-privacy"
                    className="vs-checkbox"
                    checked={privacy}
                    onChange={(e) =>
                    setPrivacy(e.target.checked)}
                  />
                  <label htmlFor="vs-privacy" className="vs-privacy-label">
                    I understand and agree to the{" "}
                    <a href="#" className="vs-privacy-link">privacy policy</a>.
                  </label>
                </div>

                {/* Submit */}
                <button type="submit" className="vs-submit-btn">
                  Submit request
                </button>

              </form>
            )}
          </div>

          {/* RIGHT — Image */}
          <div className="vs-card-right">
            <img
              // src="https://images.unsplash.com/photo-1593113598332-cd288d649433?w=800&q=80"
              src={volunteerImg}
              alt="Charity volunteers working together"
              className="vs-card-image"
            />
          </div>

        </div>
      </div>
    </>
  );
};

export default VolunteerSection;